if (!customElements.get('nelko-pdp-hero')) {
  customElements.define(
    'nelko-pdp-hero',
    class NelkoPdpHero extends HTMLElement {
      connectedCallback() {
        this.sectionId = this.dataset.sectionId
        this.productInfo = this.closest('product-info')
        this.moneyFormat = this.dataset.moneyFormat || '${{amount}}'
        this.addButtonLabel = this.dataset.addButtonLabel || 'Add To Bag'
        this.discountLabelOverride = this.dataset.discountLabelOverride || ''
        this.defaultColor = this.dataset.defaultColor || ''
        this.defaultQuantity = parseInt(this.dataset.defaultQuantity || '1', 10)
        this.defaultPostcode = this.dataset.defaultPostcode || ''
        this.deliveryLookupEndpoint = this.dataset.deliveryLookupEndpoint || ''
        this.deliveryDetectingText = this.dataset.deliveryDetectingText || ''
        this.deliveryUnavailableText = this.dataset.deliveryUnavailableText || ''
        this.deliveryStorageKey = 'nelko_delivery_postcode'
        this.hasVariantParam = new URLSearchParams(window.location.search).has('variant')
        this.initialDefaultsApplied = false
        this.initialQuantityApplied = false
        this.quantityInput = this.querySelector('.quantity__input')
        this.mediaGallery = this.querySelector('media-gallery')
        this.variantSelectors = this.getVariantSelectors()
        this.galleryTabs = this.querySelectorAll('[data-gallery-tab]')
        this.deliveryTrigger = this.querySelector('[data-delivery-postcode-trigger]')
        this.deliveryValue = this.querySelector('[data-delivery-postcode-value]')
        this.deliveryDialog = this.querySelector('[data-delivery-dialog]')
        this.deliveryPanel = this.querySelector('[data-delivery-panel]')
        this.deliveryForm = this.querySelector('[data-delivery-form]')
        this.deliveryInput = this.querySelector('[data-delivery-postcode-input]')
        this.deliveryStatus = this.querySelector('[data-delivery-status]')
        this.deliveryDetect = this.querySelector('[data-delivery-detect]')
        this.handleDeliveryKeydownBound = this.handleDeliveryKeydown.bind(this)

        this.syncButtonLabels()
        this.bindSwatches()
        this.bindMediaDots()
        this.bindGalleryTabs()
        this.bindQuantity()
        this.bindDelivery()
        this.applySavedDeliveryPostcode()
        this.detectInitialDeliveryPostcode()
        this.syncFromVariant(this.getCurrentVariant())
        this.syncActiveMediaDot()
        this.applyInitialDefaults()

        if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
          this.variantChangeUnsubscribe = subscribe(PUB_SUB_EVENTS.variantChange, this.handleVariantChange.bind(this))
        }

        const mediaList = this.querySelector('.product__media-list')
        if (mediaList) {
          this.mediaObserver = new MutationObserver(this.syncActiveMediaDot.bind(this))
          this.mediaObserver.observe(mediaList, {
            subtree: true,
            attributes: true,
            attributeFilter: ['class'],
          })
        }
      }

      disconnectedCallback() {
        if (this.variantChangeUnsubscribe) this.variantChangeUnsubscribe()
        if (this.mediaObserver) this.mediaObserver.disconnect()
        document.removeEventListener('keydown', this.handleDeliveryKeydownBound)
      }

      bindSwatches() {
        const swatches = this.querySelectorAll('[data-option-value]')

        for (const swatch of swatches) {
          swatch.addEventListener('click', this.handleSwatchClick.bind(this))
        }
      }

      bindMediaDots() {
        const dots = this.querySelectorAll('.nelko-pdp-gallery__dot[data-media-target], .nelko-pdp-gallery__dot[data-hero-image]')

        for (const dot of dots) {
          dot.addEventListener('click', this.handleMediaDotClick.bind(this))
        }
      }

      /**
       * 绑定主图下方媒体 Tab 切换
       */
      bindGalleryTabs() {
        for (const tab of this.galleryTabs) {
          tab.addEventListener('click', this.handleGalleryTabClick.bind(this))
        }
      }

      bindQuantity() {
        if (!this.quantityInput) return
        this.quantityInput.addEventListener('change', this.updateTotals.bind(this))
      }

      /**
       * 绑定配送位置弹窗交互
       */
      bindDelivery() {
        if (this.deliveryTrigger) {
          this.deliveryTrigger.addEventListener('click', this.openDeliveryDialog.bind(this))
        }

        if (this.deliveryForm) {
          this.deliveryForm.addEventListener('submit', this.handleDeliverySubmit.bind(this))
        }

        if (this.deliveryDetect) {
          this.deliveryDetect.addEventListener('click', this.handleDeliveryDetectClick.bind(this))
        }

        const closeButtons = this.querySelectorAll('[data-delivery-close]')
        for (const closeButton of closeButtons) {
          closeButton.addEventListener('click', this.closeDeliveryDialog.bind(this))
        }
      }

      /**
       * 读取本地保存的邮编并更新页面
       */
      applySavedDeliveryPostcode() {
        const savedPostcode = this.getStoredDeliveryPostcode()

        if (savedPostcode) {
          this.updateDeliveryPostcode(savedPostcode, false)
          return
        }

        if (this.defaultPostcode) {
          this.updateDeliveryPostcode(this.defaultPostcode, false)
        }
      }

      /**
       * 打开配送位置弹窗
       */
      openDeliveryDialog() {
        if (!this.deliveryDialog) return

        this.deliveryDialog.hidden = false
        document.addEventListener('keydown', this.handleDeliveryKeydownBound)

        if (this.deliveryInput && this.deliveryValue) {
          this.deliveryInput.value = this.deliveryValue.textContent.trim()
        }

        window.setTimeout(function focusDeliveryPanel() {
          if (this.deliveryInput) {
            this.deliveryInput.focus()
            this.deliveryInput.select()
            return
          }

          this.deliveryPanel?.focus()
        }.bind(this), 0)
      }

      /**
       * 关闭配送位置弹窗
       */
      closeDeliveryDialog() {
        if (!this.deliveryDialog) return

        this.deliveryDialog.hidden = true
        document.removeEventListener('keydown', this.handleDeliveryKeydownBound)
        this.setDeliveryStatus('')

        if (this.deliveryTrigger) {
          this.deliveryTrigger.focus()
        }
      }

      /**
       * 处理配送弹窗键盘关闭
       */
      handleDeliveryKeydown(event) {
        if (event.key === 'Escape') {
          this.closeDeliveryDialog()
        }
      }

      /**
       * 提交用户输入的邮编
       */
      handleDeliverySubmit(event) {
        event.preventDefault()

        const postcode = this.normalizeDeliveryPostcode(this.deliveryInput?.value || '')
        if (!postcode) {
          this.setDeliveryStatus(this.deliveryUnavailableText)
          return
        }

        this.updateDeliveryPostcode(postcode, true)
        this.closeDeliveryDialog()
      }

      /**
       * 点击后通过配置的接口识别当前位置
       */
      async handleDeliveryDetectClick() {
        await this.detectDeliveryPostcode(true)
      }

      /**
       * 初次进入页面时尝试通过配置接口识别位置
       */
      detectInitialDeliveryPostcode() {
        if (this.getStoredDeliveryPostcode()) return
        if (!this.deliveryLookupEndpoint) return

        this.detectDeliveryPostcode(false)
      }

      /**
       * 请求配送位置接口并更新邮编
       */
      async detectDeliveryPostcode(showStatus) {
        if (!this.deliveryLookupEndpoint) return

        if (showStatus) {
          this.setDeliveryStatus(this.deliveryDetectingText)
        }

        try {
          const response = await fetch(this.deliveryLookupEndpoint, {
            credentials: 'same-origin',
            headers: {
              Accept: 'application/json',
            },
          })

          if (!response.ok) throw new Error('Delivery lookup failed')

          const data = await response.json()
          const postcode = this.extractDeliveryPostcode(data)

          if (!postcode) throw new Error('Delivery postcode missing')

          this.updateDeliveryPostcode(postcode, true)
          this.setDeliveryStatus('')
        } catch (error) {
          console.error(error)
          if (showStatus) {
            this.setDeliveryStatus(this.deliveryUnavailableText)
          }
        }
      }

      /**
       * 从接口响应中提取邮编字段
       */
      extractDeliveryPostcode(data) {
        if (!data || typeof data !== 'object') return ''

        return this.normalizeDeliveryPostcode(
          data.postal_code || data.postalCode || data.zip || data.postcode || data.postal || ''
        )
      }

      /**
       * 更新页面和弹窗中的邮编
       */
      updateDeliveryPostcode(postcode, shouldStore) {
        const normalizedPostcode = this.normalizeDeliveryPostcode(postcode)
        if (!normalizedPostcode) return

        if (this.deliveryValue) {
          this.deliveryValue.textContent = normalizedPostcode
        }

        if (this.deliveryInput) {
          this.deliveryInput.value = normalizedPostcode
        }

        if (shouldStore) {
          this.storeDeliveryPostcode(normalizedPostcode)
        }
      }

      /**
       * 标准化邮编输入
       */
      normalizeDeliveryPostcode(value) {
        return String(value || '').trim().slice(0, 16)
      }

      /**
       * 读取本地保存的邮编
       */
      getStoredDeliveryPostcode() {
        try {
          return this.normalizeDeliveryPostcode(window.localStorage.getItem(this.deliveryStorageKey))
        } catch (error) {
          return ''
        }
      }

      /**
       * 保存用户选择的邮编
       */
      storeDeliveryPostcode(postcode) {
        try {
          window.localStorage.setItem(this.deliveryStorageKey, postcode)
        } catch (error) {
          console.error(error)
        }
      }

      /**
       * 更新配送弹窗状态文案
       */
      setDeliveryStatus(message) {
        if (!this.deliveryStatus) return

        this.deliveryStatus.textContent = message || ''
      }

      syncButtonLabels() {
        const mainSubmitLabel = this.querySelector('.nelko-pdp-summary__submit [name="add"] span')
        if (mainSubmitLabel) {
          mainSubmitLabel.textContent = this.addButtonLabel
        }
      }

      handleVariantChange(event) {
        if (event?.data?.sectionId !== this.sectionId) return

        this.refreshQuantityInput()
        this.restoreQuantityAfterVariantChange()
        this.syncFromVariant(event.data.variant)
        this.updateHeroMedia(event.data.html)
        this.applyInitialQuantity()

        window.setTimeout(function syncDotAfterVariantRender() {
          this.syncActiveMediaDot()
        }.bind(this), 0)
      }

      handleSwatchClick(event) {
        const value = event.currentTarget.dataset.optionValue
        const variantSelectors = this.getVariantSelectors()
        if (!value || !variantSelectors) return

        this.pendingQuantityValue = this.quantityInput?.value || ''

        const radioInputs = Array.from(variantSelectors.querySelectorAll('input[type="radio"]'))
        const matchingRadio = radioInputs.find(function (input) {
          return input.value === value
        })

        if (matchingRadio) {
          matchingRadio.checked = true
          matchingRadio.dispatchEvent(new Event('change', { bubbles: true }))
          return
        }

        const selectInput = variantSelectors.querySelector('select')
        if (selectInput) {
          selectInput.value = value
          selectInput.dispatchEvent(new Event('change', { bubbles: true }))
        }
      }

      handleMediaDotClick(event) {
        const dot = event.currentTarget
        this.selectHeroMediaDot(dot)
        this.syncActiveGalleryTabFromDot(dot)
      }

      /**
       * 根据圆点切换橱窗主图
       */
      selectHeroMediaDot(dot) {
        const mediaId = dot.dataset.mediaTarget

        if (mediaId && this.mediaGallery?.setActiveMedia) {
          this.mediaGallery.setActiveMedia(mediaId, false)
        }

        this.updateHeroImageFromDot(dot)
        this.syncActiveHeroDot(dot)
        this.syncActiveMediaDot()
      }

      /**
       * 点击 Tab 后切换到对应顺序的商品媒体
       */
      handleGalleryTabClick(event) {
        const tab = event.currentTarget
        const tabIndex = parseInt(tab.dataset.tabIndex || '0', 10)
        const dots = Array.from(this.querySelectorAll('.nelko-pdp-gallery__dot'))
        const matchedDot = tab.dataset.mediaTarget
          ? dots.find((dot) => dot.dataset.mediaTarget === tab.dataset.mediaTarget)
          : dots[tabIndex]
        const mediaControl = tab.dataset.heroImage || tab.dataset.mediaTarget ? tab : matchedDot

        if (!mediaControl) return

        this.selectHeroMediaDot(mediaControl)
        if (matchedDot) this.syncActiveHeroDot(matchedDot)
        this.syncActiveGalleryTab(tab)
      }

      /**
       * 同步主图下方媒体 Tab 的选中态
       */
      syncActiveGalleryTab(activeTab) {
        for (const tab of this.galleryTabs) {
          const isActive = tab === activeTab
          tab.classList.toggle('is-active', isActive)
          tab.setAttribute('aria-pressed', isActive ? 'true' : 'false')
        }
      }

      /**
       * 通过圆点同步媒体 Tab 状态
       */
      syncActiveGalleryTabFromDot(activeDot) {
        const dots = Array.from(this.querySelectorAll('.nelko-pdp-gallery__dot'))
        const activeIndex = dots.indexOf(activeDot)

        if (activeIndex < 0) return

        for (const tab of this.galleryTabs) {
          const isActive = parseInt(tab.dataset.tabIndex || '-1', 10) === activeIndex
          tab.classList.toggle('is-active', isActive)
          tab.setAttribute('aria-pressed', isActive ? 'true' : 'false')
        }
      }

      getCurrentVariant() {
        const variantScript = this.getVariantSelectors()?.querySelector('[data-selected-variant]')
        if (!variantScript) return null

        try {
          return JSON.parse(variantScript.textContent)
        } catch (error) {
          console.error(error)
          return null
        }
      }

      /**
       * 获取当前有效的 Shopify 变体选择器
       */
      getVariantSelectors() {
        return this.querySelector('variant-selects') || this.productInfo?.querySelector('variant-selects')
      }

      /**
       * 重新读取当前数量输入框
       */
      refreshQuantityInput() {
        this.quantityInput = this.querySelector('.quantity__input')
      }

      /**
       * 变体切换后恢复用户当前数量
       */
      restoreQuantityAfterVariantChange() {
        if (!this.quantityInput || !this.pendingQuantityValue) return

        const parsedQuantity = parseInt(this.pendingQuantityValue, 10)
        const minQuantity = parseInt(this.quantityInput.getAttribute('min') || this.quantityInput.dataset.min || '1', 10)
        const maxAttribute = this.quantityInput.getAttribute('max') || this.quantityInput.dataset.max
        const maxQuantity = maxAttribute ? parseInt(maxAttribute, 10) : null

        if (!parsedQuantity || parsedQuantity < minQuantity) {
          this.quantityInput.value = String(minQuantity)
        } else if (maxQuantity && parsedQuantity > maxQuantity) {
          this.quantityInput.value = String(maxQuantity)
        } else {
          this.quantityInput.value = String(parsedQuantity)
        }

        this.pendingQuantityValue = ''
      }

      syncFromVariant(variant) {
        if (!variant) return

        this.currentVariant = variant
        this.syncButtonLabels()
        this.updatePrice(variant)
        this.updateSelectedColor(variant)
        this.updateTotals()
      }

      applyInitialDefaults() {
        if (this.initialDefaultsApplied || this.hasVariantParam) {
          this.applyInitialQuantity()
          return
        }

        this.initialDefaultsApplied = true

        if (this.defaultColor) {
        const matchingSwatch = [...this.querySelectorAll('[data-option-value]')].find(function findMatchingSwatch(swatch) {
          return swatch.dataset.optionValue === this.defaultColor
        }.bind(this))

          if (matchingSwatch && !matchingSwatch.classList.contains('is-active')) {
            matchingSwatch.click()
            return
          }
        }

        this.applyInitialQuantity()
      }

      applyInitialQuantity() {
        if (this.initialQuantityApplied || !this.quantityInput || !this.currentVariant) return
        if (!this.defaultQuantity || this.defaultQuantity <= 1) {
          this.initialQuantityApplied = true
          return
        }

        this.quantityInput.value = String(this.defaultQuantity)
        this.quantityInput.dispatchEvent(new Event('change', { bubbles: true }))
        this.initialQuantityApplied = true
      }

      updatePrice(variant) {
        const priceNode = this.querySelector('[data-main-price]')
        const compareNode = this.querySelector('[data-main-compare]')
        const discountNode = this.querySelector('[data-main-discount]')
        const onSale = variant.compare_at_price && variant.compare_at_price > variant.price

        if (priceNode) priceNode.textContent = this.formatMoney(variant.price)

        if (compareNode) {
          compareNode.textContent = onSale ? this.formatMoney(variant.compare_at_price) : ''
          compareNode.classList.toggle('is-hidden', !onSale)
        }

        if (discountNode) {
          const discountLabel = this.discountLabelOverride || `${this.getDiscountPercent(variant.price, variant.compare_at_price)}% Off`
          discountNode.textContent = onSale ? discountLabel : ''
          discountNode.classList.toggle('is-hidden', !onSale)
        }
      }

      /**
       * 使用变体刷新后的 Liquid HTML 更新主图区域
       */
      updateHeroMedia(html) {
        const sourceMedia = html?.querySelector?.('.nelko-pdp-gallery__hero-media')
        const currentMedia = this.querySelector('.nelko-pdp-gallery__hero-media')

        if (!sourceMedia || !currentMedia) return

        currentMedia.innerHTML = sourceMedia.innerHTML
        this.bindMediaDots();
        this.bindGalleryTabs();
      }

      /**
       * 使用当前圆点携带的图片 URL 更新主图
       */
      updateHeroImageFromDot(dot) {

    const heroImage = this.querySelector('.nelko-pdp-gallery__hero-image');

    if (!heroImage) return;

    const videoUrl = dot.dataset.video;

    // 删除旧视频
    const oldVideo = this.querySelector('.nelko-pdp-gallery__hero-video');
    if (oldVideo) {
        oldVideo.remove();
    }

    // Video
    if (videoUrl) {

        heroImage.style.display = 'none';

        const video = document.createElement('video');

        video.className = 'nelko-pdp-gallery__hero-video';
        video.controls = true;
        video.autoplay = true;
        video.playsInline = true;
        video.style.width = '100%';

        video.src = videoUrl;

        heroImage.parentNode.appendChild(video);

        return;
    }

    // Image
    heroImage.style.display = '';

    heroImage.src = dot.dataset.heroImage;
    heroImage.alt = dot.dataset.heroAlt || '';
    }


      /**
       * 同步自定义主图圆点选中态
       */
      syncActiveHeroDot(activeDot) {
        const dots = this.querySelectorAll('.nelko-pdp-gallery__dot')

        for (const dot of dots) {
          dot.classList.toggle('is-active', dot === activeDot)
        }
      }

      updateSelectedColor(variant) {
        const colorLabel = this.querySelector('[data-selected-color]')
        const optionValue = variant.options && variant.options.length ? variant.options[0] : ''

        if (colorLabel) colorLabel.textContent = optionValue

        const swatches = this.querySelectorAll('[data-option-value]')
        for (const swatch of swatches) {
          swatch.classList.toggle('is-active', swatch.dataset.optionValue === optionValue)
        }
      }

      updateTotals() {
        if (!this.currentVariant) return

        const quantity = this.quantityInput ? parseInt(this.quantityInput.value || '1', 10) : 1
        const totalPrice = this.currentVariant.price * quantity
        const totalCompare = this.currentVariant.compare_at_price ? this.currentVariant.compare_at_price * quantity : 0
        const onSale = totalCompare > totalPrice

        const totalPriceNode = this.querySelector('[data-total-price]')
        const totalCompareNode = this.querySelector('[data-total-compare]')

        if (totalPriceNode) totalPriceNode.textContent = this.formatMoney(totalPrice)

        if (totalCompareNode) {
          totalCompareNode.textContent = onSale ? this.formatMoney(totalCompare) : ''
          totalCompareNode.classList.toggle('is-hidden', !onSale)
        }
      }

      syncActiveMediaDot() {
        const activeMedia = this.querySelector('.product__media-item.is-active')
        const activeMediaId = activeMedia?.dataset.mediaId

        if (!activeMediaId) return

        const dots = this.querySelectorAll('.nelko-pdp-gallery__dot[data-media-target], .nelko-pdp-gallery__dot[data-hero-image]')
        for (const dot of dots) {
          dot.classList.toggle('is-active', dot.dataset.mediaTarget === activeMediaId)
        }
      }

      formatMoney(amount) {
        if (window.Shopify && typeof window.Shopify.formatMoney === 'function') {
          return window.Shopify.formatMoney(amount, this.moneyFormat)
        }

        return `$${(amount / 100).toFixed(2)}`
      }

      getDiscountPercent(price, compareAtPrice) {
        if (!compareAtPrice || compareAtPrice <= price) return 0
        return Math.round(((compareAtPrice - price) / compareAtPrice) * 100)
      }
    }
  )
}

function getNelkoPdpAnchorScrollOffset() {
  const header = document.querySelector('.section-header')
  const headerHeight = header ? header.getBoundingClientRect().height : 0

  return Math.round(headerHeight + 24)
}

function handleNelkoPdpOverviewTabClick(event) {
  const tab = event.currentTarget
  const targetId = tab.hash ? tab.hash.slice(1) : ''
  if (!targetId) return

  const target = document.getElementById(targetId)
  if (!target) return

  event.preventDefault()

  const tabs = tab.closest('.nelko-pdp-overview__tabs')?.querySelectorAll('.nelko-pdp-overview__tab') || []
  for (const item of tabs) {
    item.classList.toggle('is-active', item === tab)
  }

  const targetTop = target.getBoundingClientRect().top + window.scrollY - getNelkoPdpAnchorScrollOffset()
  window.scrollTo({
    top: Math.max(targetTop, 0),
    behavior: window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth',
  })

  window.history.pushState(null, '', `#${targetId}`)
}

function initializeNelkoPdpOverviewTabs(root = document) {
  const tabs = root.querySelectorAll('.nelko-pdp-overview__tab[href^="#"]')

  for (const tab of tabs) {
    if (tab.dataset.smoothScrollBound === 'true') continue

    tab.dataset.smoothScrollBound = 'true'
    tab.addEventListener('click', handleNelkoPdpOverviewTabClick)
  }
}

initializeNelkoPdpOverviewTabs()

document.addEventListener('shopify:section:load', (event) => {
  initializeNelkoPdpOverviewTabs(event.target)
})




document.querySelectorAll('.nelko-pdp-summary__button').forEach(button => {

    button.addEventListener('click', function () {

        const position = Number(this.dataset.optionPosition);
        const value = this.dataset.optionValue;

        // 当前组选中状态
        const group = this.closest('.nelko-pdp-summary__buttons');

        group.querySelectorAll('.nelko-pdp-summary__button').forEach(btn=>{
            btn.classList.remove('is-active');
        });

        this.classList.add('is-active');

        // 同步到隐藏 Variant Picker
        const fieldsets = document.querySelectorAll('variant-selects fieldset');

        const fieldset = fieldsets[position - 1];

        if (!fieldset) return;

        const radio = [...fieldset.querySelectorAll('input[type="radio"]')]
            .find(input => input.value === value);

        if (!radio) return;

        radio.checked = true;

        radio.dispatchEvent(new Event('change',{
            bubbles:true
        }));

    });

});


